import { isDevMode } from '@angular/core';
import { provideTransloco } from '@jsverse/transloco';
import { TranslocoHttpLoader } from './transloco-loader';
import { DEFAULT_LOCALE, FALLBACK_LOCALE } from './locales';

export const translocoProviders = provideTransloco({
  config: {
    availableLangs: ['pt-BR', 'en'],
    defaultLang: DEFAULT_LOCALE,
    fallbackLang: FALLBACK_LOCALE,
    reRenderOnLangChange: true,
    prodMode: !isDevMode(),
    missingHandler: {
      useFallbackTranslation: true,
    },
  },
  loader: TranslocoHttpLoader,
});
